module.exports = __webpack_public_path__ + "static/media/angle-arrow-down-hover.53c1cd25.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/angle-arrow-down-hover.png
// module id = 88
// module chunks = 0